import sharedReactSetup from "app/scripts/shared_react_setup"

// Libraries
import "shared/utils/initialize_highcharts"

// React Components
import StaticAppletComposer from "partners/components/static_applet_composer"
import ServiceSelect from "partners/components/org_service_select"
import ImageUploader from "partners/components/image_uploader"
import TriggerForm from "partners/components/trigger_form/trigger_form"
import TriggerFieldsForm from "partners/components/trigger_fields_form/trigger_fields_form"
import ActionFieldsForm from "partners/components/action_fields/action_fields_form"
import IngredientForm from "partners/components/ingredient_form/ingredient_form"
import IngredientTextField from "shared/components/stored_fields/ingredient_text_field/index"
import PermissionForm from "partners/components/permission_form/permission_form"
import QueryRouter from "partners/components/queries/query_router"
import EndpointTest from "partners/components/endpoint_test/main"
import AdapterScript from "partners/components/adapter_script"
import AuthenticationTest from "partners/components/authentication_test/main"
import Review from "partners/components/review/main"
import PlatformFeedbackCard from "partners/components/platform_feedback/platform_feedback_card"
import PlatformFeedbackPage from "partners/components/platform_feedback/platform_feedback_page"
import SubmitForReview from "partners/components/submit_for_review"
import AppletDefaults from "partners/components/applet_defaults/main"
import EmbeddedRedirectUris from "partners/components/embedded_redirect_uris"
import CloneDelete from "partners/components/service_tools/clone_delete"
import AdminPanel from "partners/components/admin_panel"
import OrganizationContainer from "partners/components/organizations/organization_container"
import ErrorSuccessHistogramChart from "shared/components/error_success_histogram_chart"
import ErrorBreakdownChart from "partners/components/charts/error_breakdown_chart"
import PerformanceTriggerActionChart from "shared/components/performance_trigger_action_chart"
import DynamicApplet from "partners/components/dynamic_applet_composer/main"
import DynamicAppletReview from "partners/components/dynamic_applet_composer/review"
import AppletFeedback from "partners/components/applet_feedback/main"
import PartnerUpdates from "partners/components/partner_updates"
import DeveloperChecklistItem from "app/components/developer_checklist/item.tsx"

// Service Analytics
import Overview from "partners/components/service_analytics/overview"
import Steps from "partners/components/service_analytics/steps"

import ConnectionStartScreen from "partners/components/connection_start_screen/"

// Scripts
import Sortable from "sortablejs/modular/sortable.core.esm.js"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import AuthenticationForm from "partners/scripts/authentication_form"
import StepFieldsActions from "partners/scripts/step_fields_actions"
import AdminActions from "partners/scripts/admin_actions"
import ReviewUtils from "partners/scripts/review_utils"
import archiveApplet, { unarchiveApplet } from "partners/scripts/archive_applet"
import displayFlash from "partners/scripts/display_flash"
import disableRestrictedForm from "partners/scripts/disable_restricted_form"
import docsSetup from "partners/scripts/docs_setup"
import ingredientsSortable from "partners/scripts/ingredients_sortable"
import triggerFieldsSortable from "partners/scripts/trigger_fields_sortable"
import actionsSortable from "partners/scripts/actions_sortable"
import actionFieldsSortable from "partners/scripts/action_fields_sortable"
import reviewPipelineActions from "partners/scripts/review_pipeline_actions"
import triggersSortable from "partners/scripts/triggers_sortable"
import readonlySelect from "partners/scripts/readonly_actions"
import checklistHashRedirect from "partners/scripts/checklist_redirects"
import formTrimInput from "partners/scripts/form_trim_input"
import pinApplets from "partners/scripts/pin_applets"
import openRemoteLinksInNewWindow from "app/scripts/open_remote_links_in_new_window"
import handleRecaptcha from "shared/handle_recaptcha"
import SwapBGColorsBelowElement from "app/scripts/swap_bg_colors"
import { PlatformAppletList } from "shared/components/applet_list"
import fetchUserFeedbackInfoSections from "partners/scripts/fetch_user_feedback_info_sections"
import popZendeskWidget from "partners/scripts/open_zendesk_widget_on_links"
import SetupUnifiedHeaderDropdown from "shared/scripts/setup_unified_header_dropdown"

import "stylesheets/partners.scss"

sharedReactSetup()

Object.assign(window.App.Comps, {
  DeveloperChecklistItem,
  StaticAppletComposer,
  ServiceSelect,
  ImageUploader,
  TriggerForm,
  TriggerFieldsForm,
  IngredientTextField,
  IngredientForm,
  QueryRouter,
  PermissionForm,
  EndpointTest,
  AdapterScript,
  AuthenticationTest,
  Review,
  PlatformFeedbackCard,
  PlatformFeedbackPage,
  SubmitForReview,
  ActionFieldsForm,
  ErrorSuccessHistogramChart,
  ErrorBreakdownChart,
  PerformanceTriggerActionChart,
  AppletDefaults,
  PartnerUpdates,
  EmbeddedRedirectUris,
  DynamicApplet,
  DynamicAppletReview,
  AppletFeedback,
  ConnectionStartScreen,
  ServiceTools: {
    CloneDelete,
  },
  AdminPanel,
  OrganizationContainer,
  ServiceAnalytics: {
    Overview,
    Steps,
  },
  PlatformAppletList,
})

Object.assign(window.App.Scripts, {
  openRemoteLinksInNewWindow,
  handleRecaptcha,
  SwapBGColorsBelowElement,
  SetupUnifiedMobileMenu,
  SetupUnifiedHeaderDropdown,
  partners: {
    docsSetup,
    sortable: Sortable,
    AuthenticationForm,
    StepFieldsActions,
    AdminActions,
    ReviewUtils,
    archiveApplet,
    unarchiveApplet,
    displayFlash,
    disableRestrictedForm,
    ingredientsSortable,
    triggerFieldsSortable,
    actionsSortable,
    actionFieldsSortable,
    triggersSortable,
    reviewPipelineActions,
    readonlySelect,
    checklistHashRedirect,
    formTrimInput,
    pinApplets,
    fetchUserFeedbackInfoSections,
    popZendeskWidget,
  },
})

document.addEventListener("DOMContentLoaded", () => {
  // Some click listerners wasn't more global. Call directly on Platform until we move to the new way.
  window.App.Scripts.partners.disableRestrictedForm()
  window.App.Scripts.partners.formTrimInput()
  window.App.Scripts.partners.readonlySelect()
  window.App.Scripts.partners.checklistHashRedirect()
  window.App.Scripts.partners.popZendeskWidget()
  window.scrollTo(0, 0)
})
